// tslint:disable max-line-length
import { sum, uniqBy, replace } from 'lodash';

export const getAssessmentPercentageCompleted = (
    duplicateCategoryList,
    categoryList,
    templateGroupCommentaryList,
    scoreList,
    assessmentEq: any,
    commentary: any,
    assessmentType
) => {
    let isFullyCompleted = true;
    const duplicateCategoryPercentageCompletedList = duplicateCategoryList
        .reduce((acc: number[], item) => {
            const category = categoryList.find(o => o.uuid === item.templateCategoryUuid); // [item.templateCategoryUuid];
            const assessmentEqData = assessmentEq.find((o: any) => o.duplicateCategoryUuid === item.uuid);
            const percentageCompleted = getDuplicateCategoryPercentageCompleted(item, category, templateGroupCommentaryList, scoreList, assessmentEqData, commentary, assessmentType);
            if (percentageCompleted !== 100) {
                isFullyCompleted = false;
            }
            if (percentageCompleted !== undefined) {
                acc.push(percentageCompleted);
            }
            return acc;
        }, []);

    return duplicateCategoryPercentageCompletedList.length > 0
        ? (
            isFullyCompleted
                ? Math.round(sum(duplicateCategoryPercentageCompletedList) / duplicateCategoryPercentageCompletedList.length)
                : Math.floor(sum(duplicateCategoryPercentageCompletedList) / duplicateCategoryPercentageCompletedList.length)
        )
        : 0;
};
const getDuplicateCategoryPercentageCompleted = (
  duplicateCategory,
  category,
  templateGroupCommentaryList,
  scoreList,
  assessmentEq: any,
  commentary: any,
  assessmentType,
) => {
  const templateStandardsCount = getTemplateStandardsCount(category, templateGroupCommentaryList);
  const scores = getScoresForPercent(duplicateCategory, scoreList, category, commentary, assessmentType);
  const uniqueScores = uniqBy(scores, 'templateStandardId');
  let totalWeitage = 0;
  let noofSectionFilled = 0;
  if (assessmentType !== 'self') {
      if (category.isOutletIncluded) {
          totalWeitage++;
      }
      if (category.isDateTimeRequired) {
          totalWeitage++;
      }
      if (category.isEqEnabled) {
          totalWeitage += 6;
      }
  }
  if (duplicateCategory && category && category.dateTimeFormat && ((category.dateTimeFormat !== 'dateOnlyRange' && !!duplicateCategory[category.dateTimeFormat]) || (duplicateCategory.fromDate && duplicateCategory.toDate))) {
      if (category.dateTimeFormat === 'dateTime' && duplicateCategory.dateTime) {
          const dateTimeCheck = replace(duplicateCategory.dateTime, '.000Z', '');
          const time = dateTimeCheck.split('T');
          if (time.length > 0 && time[1] !== '00:49:49' && assessmentType !== 'self') {
              noofSectionFilled++;
          }

      } else if (assessmentType !== 'self') {
          noofSectionFilled++;
      }
  }
  if (assessmentType !== 'self') {
      if (duplicateCategory && !!duplicateCategory.outlet) {
          noofSectionFilled++;
      }
      if (assessmentEq && !!assessmentEq.categoryEqDescription) {
          noofSectionFilled++;
      }
      if (assessmentEq && !!assessmentEq.templateEqId) {
          noofSectionFilled++;
      }
      if (assessmentEq && assessmentEq.positiveText && !!assessmentEq.positiveText.length) {
          noofSectionFilled++;
      }
      if (assessmentEq && assessmentEq.negativeText && !!assessmentEq.negativeText.length) {
          noofSectionFilled++;
      }
      if (assessmentEq && assessmentEq.recommendText && !!assessmentEq.recommendText.length) {
          noofSectionFilled++;
      }
      if (assessmentEq && assessmentEq.additionalText && !!assessmentEq.additionalText.length) {
          noofSectionFilled++;
      }
  }

  return templateStandardsCount > 0 ? ((uniqueScores.length + noofSectionFilled) / (templateStandardsCount + totalWeitage)) * 100 : undefined;
};
const getTemplateStandardsCount = (
  category,
  templateGroupCommentaryList,
) => {
  const templateStandardUuidList: string[] = getTemplateStandardUuidList(category);
  const templateStandardInGroupUuidList: string[] = getTemplateStandardInGroupUuidList(category, templateGroupCommentaryList);
  return [...templateStandardUuidList, ...templateStandardInGroupUuidList].length;
};
const getTemplateStandardUuidList = (category): string[] => category.items
    .filter(ref => ref.schema === 'templateStandard' && ref.scoringType !== 700)
    .map((ref) => ref.id);
const getTemplateStandardInGroupUuidList = (
      category,
      templateGroupCommentaryList,
  ): string[] => category.items
      .filter(ref => ref.schema === 'groupCommentary')
      .reduce((acc: string[], ref: {id: string, schema: string}) => {
          templateGroupCommentaryList[ref.id].items.forEach(id => acc.push(id));
          return acc;
      }, []);
const getScoresForPercent = (
  duplicateCategory,
  scoreList,
  category,
  commentary: any,
  assessmentType) => {
  
  const scores = scoreList
      .filter(item => {
          let commentaryData;
          if (assessmentType === 'self') {
              return duplicateCategory.scores && duplicateCategory.scores.includes(item.uuid); 
          } 
          if (commentary) {
              commentaryData = commentary.filter((o: any) => o.referenceUuid === item.templateStandardUuid);
          }
          return duplicateCategory.scores && duplicateCategory.scores.includes(item.uuid) && (item.response !== 0 || (category.commentaryType === 'templateStandard' && commentaryData.length > 0) || (category.commentaryType !== 'templateStandard'));
      });
      
  return scores;
};
